import { IGuest } from '@bridebook/models/source/models/Weddings/Guests.types';
import {
  GuestlistAnalyticsActionTypes,
  ClickedToShareGuestCollectorLinkAnalyticsPayload,
  InteractedWithGuestsOnGuestlistAnalyticsPayload,
} from '@bridebook/web/lib/guestlist/analytics/action-types';
import { IGuestlistCategory } from '@bridebook/web/lib/guestlist/types';

export const addedGuestAnalytics = (payload: {
  edit: boolean;
  guest: IGuest;
  method: 'inline' | 'plus1';
}) => ({
  type: 'ADDED_GUEST_ANALYTICS',
  payload,
});

export const addedMultipleGuestsAnalytics = (payload: {
  category: IGuestlistCategory;
  count: number;
  method: 'inline' | 'popup' | 'importContacts';
}) => ({
  type: GuestlistAnalyticsActionTypes.ADDED_MULTIPLE_GUESTS,
  payload,
});

export const clickedDeleteGuestAnalytics = () => ({
  type: 'CLICKED_DELETE_GUEST_ANALYTICS',
});

export const deletedGuestAnalytics = () => ({
  type: 'DELETED_GUEST_ANALYTICS',
});

export const clickedResetGuestlistAnalytics = () => ({
  type: 'CLICKED_RESET_GUESTLIST_ANALYTICS',
});

export const resetGuestlistAnalytics = () => ({
  type: 'RESET_GUESTLIST_ANALYTICS',
});

export const cancelResetGuestlistAnalytics = () => ({
  type: 'CANCELLED_RESET_GUESTLIST_ANALYTICS',
});

export const initialisedGuestlistAnalytics = (
  method: 'bulkAddGuestPopup' | 'importContacts' | 'emptyGuestList',
) => ({
  type: GuestlistAnalyticsActionTypes.INITIALISED_GUESTLIST,
  payload: { method },
});

export const toggleBulkAddGuestsMethodAnalytics = (
  method: 'bulkAddGuestPopup' | 'importContacts',
) => ({
  type: GuestlistAnalyticsActionTypes.TOGGLE_BULK_ADD_METHOD,
  payload: { method },
});

export type ClickedAddGuestsMethod =
  | 'addGuestsManually'
  | 'importFromSpreadsheet'
  | 'importContacts';

export type ClickedAddGuestsSection = 'addGuestsDrawer' | 'emptyGuestList' | 'desktopDropDown';

export type ClickedAddGuestsCta =
  | 'Add'
  | 'Import'
  | 'Upload file'
  | 'Upload file again'
  | 'Confirm import'
  | 'Template';

export const clickedAddGuestsAnalytics = (payload: {
  method: ClickedAddGuestsMethod;
  clickedSection?: ClickedAddGuestsSection;
  cta?: ClickedAddGuestsCta;
}) => ({
  type: GuestlistAnalyticsActionTypes.CLICKED_ADD_GUESTS,
  payload,
});

export const toggleGuestCollectorPopupAnalytics = (payload: { show: boolean }) => ({
  type: payload.show
    ? GuestlistAnalyticsActionTypes.OPENED_GUEST_COLLECTOR_POPUP
    : GuestlistAnalyticsActionTypes.CLOSED_GUEST_COLLECTOR_POPUP,
  payload,
});

export const clickedToShareGuestCollectorLinkAnalytics = (
  payload: ClickedToShareGuestCollectorLinkAnalyticsPayload,
) => ({
  type: GuestlistAnalyticsActionTypes.CLICKED_TO_SHARE_GUEST_COLLECTOR_LINK,
  payload,
});

export const sharedGuestCollectorLinkAnalytics = (payload: {
  url: string;
  appChosen?: string;
  collectGuestInfoPopupLocation?: string;
  section?: string;
}) => ({
  type: GuestlistAnalyticsActionTypes.SHARED_GUEST_COLLECTOR_LINK,
  payload,
});

export const interactedWithGuestsOnGuestlistAnalytics = (
  payload: InteractedWithGuestsOnGuestlistAnalyticsPayload,
) => ({
  type: GuestlistAnalyticsActionTypes.INTERACTED_WITH_GUESTS_ON_GUESTLIST,
  payload,
});
